// extracted by mini-css-extract-plugin
export default {"btnDownload":"ButtonDownload_btnDownload__Ans48"};